import React, { useState } from 'react';
import { BrowserRouter as Router } from 'react-router-dom';
import { Layout } from 'antd';
import 'antd/dist/antd.css';
import AppContextProvider from 'context/AppContext';

import LayoutApp from './LayoutApp';

const App = () => {
    const [userData, setUserData] = useState([]);
    return (
        <>
            <AppContextProvider>
                <Router basename="/app">
                    <LayoutApp />
                </Router>
            </AppContextProvider>
        </>
    );
};

export default App;
